module.exports = __webpack_public_path__ + "img/68_32.9faeb90c.png";